import manifest from "@/lib/imageManifest.json";

export const Img = ({ name, alt, sizes = "100vw", priority = false, className = "", imgClassName = "" }) => {
  const m = manifest[name];
  const set = (ext) => m.widths.map((w) => `/img/${name}-${w}.${ext} ${w}w`).join(", ");
  const max = m.widths[m.widths.length - 1];
  return (
    <picture className={className}>
      <source type="image/avif" srcSet={set("avif")} sizes={sizes} />
      <source type="image/webp" srcSet={set("webp")} sizes={sizes} />
      <img
        src={`/img/${name}-${max}.webp`}
        alt={alt}
        width={m.w}
        height={m.h}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
        className={imgClassName}
        data-testid={`img-${name}`}
      />
    </picture>
  );
};
